// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"799":"743dc5ab","850":"8a741cc8"}[chunkId] + ".js";
};